<template>
  <div class="container-fluid container-fluid px-4 rounded-4 contenedor-principal">
    <div class="row bg-white py-4 rounded-4">
      <chat-operacion 
        :id-operacion="props.idOperacion" 
        :codigo-secuencial-operacion="props.codigoSecuencialOperacion" 
        :es-backoffice="false" 
        :tipo="props.tipo"
        @detalle-operacion="handleDetalleOperacion"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ChatOperacion from "@/.shared/components/chat-operacion/ChatOperacion.vue";
import type { PropType } from "vue";
import { mostrarDetalleOperacion } from "@/services/OperacionDetalleModalFactory";

const props = defineProps({
  idOperacion: {
    type: String,
    required: true
  },
  codigoSecuencialOperacion: {
    type: String,
    required: true
  },
  tipo: {
    type: String as PropType<'ENERGIA' | 'AGUA'>,
    required: true
  }
});

const handleDetalleOperacion = async (modalConfig: {
  component: any,
  props: any,
  options: any
}) => {
  await mostrarDetalleOperacion(props.idOperacion, props.tipo);
};

</script>